import classNames from 'classnames';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Field, Form } from 'react-final-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { actions } from '../../context';
import {
    faClipboardCheck,
    faFileAlt,
    faPaperclip,
    faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import './NewCommunicationCommentForm.css';

const NewCommunicationCommentForm = (props) => {
    const { communication, onComment } = props;

    const dispatch = useDispatch();

    const submit = async (
        vals,
        form,
        complete = () => {},
        closeCommunication = false
    ) => {
        const commentText = vals?.commentText || '';
        try {
            let formData = new FormData();
            var elem = document.getElementById('commentFiles');
            if (elem)
                Array.from(elem.files).forEach((file) =>
                    formData.append('fileAttachments', file)
                );

            formData.append('comment.text', commentText);
            formData.append('comment.closeCommunication', closeCommunication);
            //https://stackoverflow.com/a/63841218/14048815
            currentlyTaggedUsers.forEach((user, index) => {
                formData.append(
                    `comment.MentionedAccounts[${index}].id`,
                    user.id
                );
                formData.append(
                    `comment.MentionedAccounts[${index}].name`,
                    user.name
                );
            });

            dispatch(
                actions.communication.postCommunicationComment(
                    communication?.id,
                    formData
                )
            ).then(
                () => {
                    onComment();
                    clearForm();
                    form.reset();
                },
                (err) => {
                    console.error(err);
                }
            );
        } catch (err) {
            console.error(err);
        }
    };

    const [files, setFiles] = useState([]);
    const [isHoldingShift, setIsHoldingShift] = useState(false);

    const [oneBack, setOneBack] = useState(-1);
    const [twoBack, setTwoBack] = useState(-1);

    //can we see the @-mention box?
    const [atBoxVisible, setAtBoxVisible] = useState(false);
    const [atPosition, setAtPosition] = useState(-1);
    const [mentionFilterString, setMentionFilterString] = useState('');
    const [people, setPeople] = useState([]);
    const [currentlyTaggedUsers, setCurrentlyTaggedUsers] = useState([]);
    const [mentionableCommentUsers, setMentionableCommentUsers] = useState([]);

    useEffect(() => {
        if (communication?.id) {
            dispatch(
                actions.communication.getCommunicationUsers(communication.id)
            ).then((res) => setMentionableCommentUsers(res?.data || []));
        }
        setCurrentlyTaggedUsers([]);
        setFiles([]);
    }, [dispatch, communication]);

    const fileInputChange = (e) => {
        setFiles([]);
        let fileList = [];
        Array.from(e.target.files).forEach((file) => fileList.push(file.name));
        setFiles(fileList);
    };

    const clearFiles = () => {
        const inputElement = document.getElementById('commentFiles');
        if (inputElement) inputElement.value = '';
        setFiles([]);
    };

    const clearForm = () => {
        clearFiles();
        setAtBoxVisible(false);
        setCurrentlyTaggedUsers([]);
    };

    //style
    const lgSize = 11;
    const getMentionBoxStyle = (count = 4) => {
        return {
            transform:
                count > 0
                    ? `translate(0px, -${55 + (count - 1) * 25}px)`
                    : `translate(0px, -55px)`,
            zIndex: '1000',
        };
    };

    const toggleAtBox = (position, val = null) => {
        if (val !== null) {
            if (val === true) {
                setAtPosition(position);
                setAtBoxVisible(val);
            } else {
                setAtBoxVisible(val);
            }
        } else {
            setAtBoxVisible(!atBoxVisible);
        }
    };

    const handleMentionedUser = (user, form) => {
        let text = document.getElementsByName('commentText')[0].value;
        let beforeAt = text.substring(0, atPosition);
        let afterAt = text
            .slice(atPosition + 1)
            .replace(mentionFilterString, '');
        const newText = `${beforeAt}@${user.firstName} ${user.lastName}${afterAt}`;
        setCurrentlyTaggedUsers([
            ...currentlyTaggedUsers,
            { name: `@${user.firstName} ${user.lastName}`, id: user.id },
        ]);
        form.commentText = newText;
        setAtBoxVisible(false);
        return form;
    };

    //handles if we're holding shift and pressing 2
    const handleKeyDownInput = (event) => {
        if (event !== null) {
            if (event.keyCode === 16) setIsHoldingShift(true);
            if (isHoldingShift && event.keyCode === 50) {
                toggleAtBox(event.target.selectionStart, true);
                setPeople(mentionableCommentUsers.slice(0, 4));
            }
        }
    };

    const resetFilterString = () => setMentionFilterString('');

    //@-mention handling
    const handleKeyUpInput = (event) => {
        //keep track of most recent keys
        setTwoBack(oneBack);
        setOneBack(event.keyCode);
        if (event !== null) {
            switch (event.keyCode) {
                case 16: //released shift
                    setIsHoldingShift(false);
                    break;
                case 27: //esc
                    toggleAtBox(-1, false);
                    resetFilterString();
                    break;
                case 8: //backspace
                default:
                    // did we just do '@'?
                    if (
                        (event.keyCode === 8 &&
                            oneBack === 16 &&
                            twoBack === 50) ||
                        event.target.selectionStart <= atPosition
                    ) {
                        toggleAtBox(-1, false);
                        resetFilterString();
                    }
                    if (event.target.selectionStart < atPosition) {
                        toggleAtBox(-1, false);
                        resetFilterString();
                        break;
                    }
                    if (atBoxVisible) {
                        const cursorPosition = event.target.selectionStart;
                        let text =
                            document.getElementsByName('commentText')[0].value;
                        const filterText = text.substring(
                            atPosition + 1,
                            cursorPosition
                        );
                        setMentionFilterString(filterText);
                        const updatedUsers = mentionableCommentUsers
                            .filter(
                                (user) =>
                                    filterText.length === 0 ||
                                    `${user.firstName} ${user.lastName}`
                                        .toLowerCase()
                                        .includes(filterText.toLowerCase())
                            )
                            .slice(0, 4);
                        setPeople(updatedUsers);
                    }
            }
        }
    };

    return (
        <Form
            onSubmit={submit}
            render={({ handleSubmit, form, submitting, pristine, values }) => (
                <form onSubmit={handleSubmit} className="mx-auto">
                    <Row className="">
                        <Col lg={lgSize} className="mx-auto">
                            <div
                                className={classNames(
                                    'position-absolute w-50 p-1 bg-light sc-rounded text-dark',
                                    { 'd-none': !atBoxVisible }
                                )}
                                style={getMentionBoxStyle(
                                    (people || [1, 1, 1, 1]).length
                                )}>
                                <div className="text-12">Mention a user</div>
                                <div className="px-1">
                                    {(people || []).length === 0 && `No users`}
                                    {(people || []).slice(0, 4).map((u, x) => (
                                        <div
                                            key={x}
                                            className="hoverable hide-overflow darken-user-on-hover px-2 rounded"
                                            onClick={() => {
                                                form = handleMentionedUser(
                                                    u,
                                                    values
                                                );
                                                document
                                                    .getElementsByName(
                                                        'commentText'
                                                    )[0]
                                                    .focus();
                                            }}>
                                            {u.firstName} {u.lastName} |{' '}
                                            {u.email}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <Field
                                autoFocus
                                component="textarea"
                                id="commentText"
                                name="commentText"
                                className="w-100 p-2 rounded my-2"
                                onKeyDown={(e) => handleKeyDownInput(e)}
                                onKeyUp={(e) => handleKeyUpInput(e)}
                                placeholder="Make a comment"
                                required
                                rows="4"
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col
                            lg={lgSize}
                            className="d-flex justify-content-between mx-auto">
                            <div>
                                <label
                                    id="uploadFiles"
                                    className="file-upload p-1 px-2">
                                    <input
                                        type="file"
                                        id="commentFiles"
                                        onChange={(e) => fileInputChange(e)}
                                        multiple
                                    />
                                    <FontAwesomeIcon
                                        icon={faPaperclip}
                                        size="lg"
                                    />
                                </label>
                                <UncontrolledTooltip target="uploadFiles">
                                    Upload a file or screenshot (28MB Max)
                                </UncontrolledTooltip>
                            </div>
                            <span>
                                <Button
                                    id="closeCommunication"
                                    size="sm"
                                    color="danger"
                                    className={classNames('mx-1', {
                                        'd-none': !communication?.isOpen,
                                    })}
                                    onClick={() =>
                                        submit(values, form, null, true)
                                    }>
                                    <FontAwesomeIcon icon={faClipboardCheck} />
                                    &emsp;
                                    {pristine ? 'Close' : 'Close with comment'}
                                </Button>
                                <UncontrolledTooltip target="closeCommunication">
                                    Mark as closed{' '}
                                    {pristine ? '' : 'with your comment'}
                                </UncontrolledTooltip>
                                &emsp;
                                <Button
                                    color="danger"
                                    size="sm"
                                    className={classNames('mx-1')}
                                    disabled={pristine}
                                    onClick={() => {
                                        form.reset();
                                        clearForm();
                                    }}>
                                    Clear
                                </Button>
                                <Button
                                    color="success"
                                    type="submit"
                                    size="sm"
                                    className="mx-1"
                                    disabled={pristine || submitting}>
                                    {communication?.isOpen
                                        ? `Comment`
                                        : pristine
                                        ? `Comment`
                                        : `Re-open with comment`}
                                </Button>
                            </span>
                        </Col>
                        <Col lg="12" md="12" sm="12" xs="12">
                            {files.map((file, index) => (
                                <div
                                    className="bg bg-info text-light d-inline-block ml-2 p-1 rounded"
                                    title={file}
                                    key={index}>
                                    <FontAwesomeIcon
                                        size="lg"
                                        icon={faFileAlt}
                                    />
                                    &emsp;{' '}
                                    <span className="w-66 hide-overflow">
                                        {file.substring(0, 20)}
                                        {file.length > 20 ? '...' : ''}
                                    </span>
                                    &emsp;{' '}
                                    <FontAwesomeIcon
                                        icon={faTimes}
                                        onClick={() => clearFiles()}
                                        size="lg"
                                        title="Remove this File"
                                        className="hoverable"
                                    />
                                </div>
                            ))}
                        </Col>
                    </Row>
                </form>
            )}></Form>
    );
};

export default NewCommunicationCommentForm;
